import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

const fetchCategory: {
  news: number;
  column: number;
  member: number;
  certification: number;
} = {
  news: 3,
  column: 4,
  member: 5,
  certification: 6,
};

type FetchParams = {
  category?: "news" | "column" | "member" | "certification";
  id?: string;
  filter?: string;
};

const REACT_APP_API_URL =
  "https://backend.dreamit-est.co.jp/wp-json/wp/v2/posts?_embed&per_page=100";

const REACT_APP_CONTACT_API_URL =
  "https://backend.dreamit-est.co.jp/wp-json/contact-form-7/v1/contact-forms";

const config = (): AxiosRequestConfig => {
  const headers = {
    ["content-type"]: "application/json",
    Authorization: `Basic ${window.btoa(
      "katanami" + ":" + process.env.REACT_APP_API_KEY
    )}`,
  };
  return {
    headers: headers,
  };
};

export const fetch = (params: FetchParams) => {
  let parameter = "";

  if (params.category) {
    parameter = `&categories=${fetchCategory[params.category]}`;
  }
  if (params.id) {
    parameter = `/${params.id}`;
  }

  return axios.get(
    `${REACT_APP_API_URL}${parameter}${
      params.filter ? "&" + params.filter : ""
    }`,
    {
      ...config(),
    }
  );
};

export const fetchForm = () => {
  return axios.get(REACT_APP_CONTACT_API_URL + "/10", {
    ...config(),
  });
};

export const postForm = async (formId: number, formData: any) => {
  const params = new FormData();
  Object.keys(formData).forEach((key: string) => {
    const value: string = formData[key];
    params.append(key, value);
  });

  const axiosConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  await axios
    .post(
      `${REACT_APP_CONTACT_API_URL}/${formId}/feedback`,
      params,
      axiosConfig
    )
    .then((res) => {
      return res.data.status;
    })
    .catch((error) => {
      console.error(error);
    });
};
